import React from "react";
import Fieldset from "../../common/Fieldset";
import PropTypes from "prop-types";
import TextInput from "../../common/TextInput";
import Row from "../../common/Row";
import NumberInput from "../../common/NumberInput";

const ContactPersoonFormItem = (props) => {
    const {
        model,
        onChange,
        errors
    } = props;

    return (
        <Fieldset title="Contactpersoon">
            <Row>
                <TextInput
                    name="voornaam"
                    label="Voornaam"
                    value={model.voornaam}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['voornaam'] : ""}
                />
                <TextInput
                    name="familienaam"
                    label="Familienaam"
                    value={model.familienaam}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['familienaam'] : ""}

                />
            </Row>
            <Row>
                <TextInput
                    name="email"
                    label="E-mailadres"
                    value={model.email}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['email'] : ""}
                />
                <TextInput
                    name="bevestigingEmail"
                    label="Bevestig je e-mailadres"
                    value={model.bevestigingEmail}
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['bevestigingEmail'] : ""}
                />
            </Row>
            <Row>
                <NumberInput
                    name="gsm"
                    label="GSM"
                    value={model.gsm}
                    originalValue={model.gsm}
                    dontParse
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['gsm'] : ""}
                />
                <NumberInput
                    name="telefoon"
                    label="Telefoon"
                    value={model.telefoon}
                    originalValue={model.telefoon}
                    dontParse
                    onChange={onChange}
                    size={6}
                    validationMessage={errors ? errors['telefoon'] : ""}
                />
            </Row>
        </Fieldset>
    );
};

ContactPersoonFormItem.propTypes = {
    onChange: PropTypes.func,
    model: PropTypes.object,
    errors: PropTypes.array
};

export default ContactPersoonFormItem;